import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { PublicLayoutComponent } from './features/public/public-layout/public-layout.component';
import { ErrorComponent, NotFoundComponent } from '@vinnova/e-tjanster';
import { LoginCallbackComponent } from '@vinnova/auth';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/assessment-listing/assessment-listing.module').then(
        (m) => m.AssessmentListingModule,
      ),
  },
  {
    path: 'terms',
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/terms/terms.module').then((m) => m.TermsModule),
  },
  {
    path: 'assessment/:assessmentId',
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/assessment/assessment.module').then(
        (m) => m.AssessmentModule,
      ),
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./features/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'login-callback',
    component: LoginCallbackComponent,
  },
  {
    path: 'not-found',
    component: PublicLayoutComponent,
    children: [
      {
        path: '',
        component: NotFoundComponent,
      },
    ],
  },
  {
    path: 'error',
    component: PublicLayoutComponent,
    children: [
      {
        path: '',
        component: ErrorComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
